/* eslint-disable react-hooks/rules-of-hooks */
import { useContext, useEffect, useState } from "react";

import { Image, notification, Tooltip } from "antd";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { t } from "i18next";

import { DEFAULT_LOGO_IMAGE } from "../Home";
import { API_URL, WL_EVENT_URL, WL_URL } from "../../../settings";
import { dashboardApi } from "../../../api/DashboardApi";
import { WhiteLabel } from "../../../interfaces/university/whitelabel";

import { ChannelContext, LoggedUser } from "../../../context/channel";

import colors from "../../../theme/colors";
import { breakpointSize } from "../../../theme/mediaQuerie";

import ListPageTopBar from "../../../components/dashboard/topBar/ListPageTopBar";
import PageWrapper from "../../../components/dashboard/pageWrapper/PageWrapper";
import { MenuPopover } from "../../../components/shared-v2/MenuPopover";
import { NewWlModalContent } from "../../../components/shared-v2/NewWlModalContent";
import CustomTable from "../../../components/shared/CustomTable";
import EventialsHeader from "../../../components/shared/EventialsHeader";
import BaseToggle from "../../../components/shared/BaseToggle";
import BaseModal from "../../../components/shared/BaseModal";
import Typography from "../../../components/shared/typography/Typography";
import PenIcon from "../../../components/shared/Icons/PenIcon";
import { ThreeDotsIcon } from "../../../components/shared/Icons/ThreeDotsIcon";
import { TrashIcon } from "../../../components/shared/Icons/TrashIcon";
import ExternalLinkIcon from "../../../components/shared/Icons/ExternalLinkIcon";

import {
  ButtonWrapper,
  Container,
  Header,
  ModalButton,
  StyledTypography,
  TableWrapper,
  TypographyWrapper,
  WhiteLabelName,
  WhiteLabelKind,
  WhiteLabelWrapper,
  Wrapper,
} from "./style";

const isMobile = window.innerWidth <= breakpointSize.Sm;


const mock = [{ "kind": "event", "name": "wl evento karol", "is_active": true, "logo": "https://static-stg.eventials.com/media/e5b0b7482c832dc425adf14e48c877341e176236/6eef6648406c333a4035cd5e60d0bf2ecf2606d7/1681479682/logotipograficoblack.svg", "is_draft": false, "slug": "wl-evento-karol" }, { "kind": "university", "name": "teste2", "is_active": true, "logo": "", "is_draft": false, "slug": "teste2" }, { "kind": "university", "name": "teste-university", "is_active": true, "logo": "https://static-stg.eventials.com/media/e5b0b7482c832dc425adf14e48c877341e176236/d0226f9e35dab55020fca272f6d56ff5812633fd/1685031539/logotipograficoblack.png", "is_draft": false, "slug": "teste-university" }, { "kind": "university", "name": "teste-request-2", "is_active": true, "logo": "", "is_draft": false, "slug": "teste-request" }, { "kind": "video-conference", "name": "teste-video-conferencia", "is_active": true, "logo": "https://static-stg.eventials.com/media/e5b0b7482c832dc425adf14e48c877341e176236/1d7deb7af392ce1dd0b07cc0e31a54ffbcbfe9fc/1706790627/logo3.png", "is_draft": false, "slug": "teste-video-conferencia" }]

const ListAndCreateWhitelabel = () => {
  const { user } = useContext(ChannelContext);
  const [listOfWl, setListOfWl] = useState<WhiteLabel[]>([]);
  const [userData, setUserData] = useState<any>(false);
  const [selectedWl, setSelectedWl] = useState<WhiteLabel>();
  const [toggleModal, setToggleModal] = useState(false);
  const breakpoints = useBreakpoint();

  const [isLoading, setIsLoading] = useState(true);

  const [showModal, setShowModal] = useState<boolean>(false);
  const [name, setName] = useState<string>("");
  const [type, setType] = useState<'university' | 'event' | "video-conference" | ''>('university');

  useEffect(() => {
    dashboardApi.getAuthentication().then((response: LoggedUser | string) => {
      if (typeof (response) === "string" && !window.location.hostname.includes("localhost")) {
        window.location.href = API_URL + "/login";
      } else {
        setUserData(response);
        setIsLoading(false);
      }
    });
  }, [user]);

  useEffect(() => {
    populateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => {
    dashboardApi.createWhiteLabel(name, type).then((response: Object | string) => {
      if (typeof response === "string") {
        notification.error({
          message: t('dashboard.createWL.error'),
          description: response,
        });
      } else {
        setName("");

        setShowModal(false);

        notification.success({
          message: t('dashboard.createWL.success.title'),
          description: t('dashboard.createWL.success.text'),
        });

        afterCreate();
      }
    });
  };


  const populateList = () => {
    dashboardApi.listWhiteLabels().then((list) => {
      if (list) {
        setListOfWl(
          list.map((e: WhiteLabel) => {
            e.key = `wl-${e.slug}`;
            return e;
          })
        );
      }
    });
  };

  const afterCreate = () => {
    populateList();
  };

  async function onToggleSwitch(active: boolean, i: number, data: any) {
    dashboardApi.editStatus(data, active);
  }

  async function onDelete() {
    dashboardApi.deleteWhiteLabel(selectedWl).then(async () => {
      setToggleModal(false);
      populateList();
    })
  }

  function getKindName(kind: string) {
    if (kind === "university") {
      return t('wl.type.university')
    }
    if (kind === "event") {
      return t('wl.type.event')
    }
    if (kind === "video-conference") {
      return t('wl.type.conference')
    }
    return ""
  }

  function onEdit(slug: string, data: WhiteLabel) {
    let url = "";
    if (data.kind === "university") {
      url = `/${slug.replace("draft-", "")}/dashboard-customization`;
    }
    if (data.kind === "event") {
      url = `/${slug.replace("draft-", "")}/event-dashboard-customization`;
    }
    if (data.kind === "video-conference") {
      url = `/${slug.replace("draft-", "")}/conference-dashboard-customization`;
    }
    return url;
  }

  function onAccess(data: WhiteLabel, link: string) {
    let url = "";

    if (data.kind === "university") {
      url = `${WL_URL}/${link}`;
    }
    if (data.kind === "event") {
      url = `${WL_EVENT_URL}/${link}`;
    }
    if (data.kind === "video-conference") {
      url = `${WL_URL}/${link}/formulario`;
    }
    window.open(url);
  }

  const columns = [
    {
      title: "White Label",
      dataIndex: "logo",
      key: "logo",

      render: (logo: string, data: WhiteLabel) => (
        <WhiteLabelWrapper>
          {!breakpoints.xs && (
            <Image
              preview={false}
              width={80}
              src={logo && logo !== "" ? logo : DEFAULT_LOGO_IMAGE}
            />
          )}
          <WhiteLabelName>{data.name}</WhiteLabelName>
          <WhiteLabelKind> {
            getKindName(data.kind)
          }
          </WhiteLabelKind>
        </WhiteLabelWrapper>
      ),
    },
    !isMobile ? {
      title: t('access'),
      dataIndex: "slug",
      key: "link",
      width: "10%",
      render: (link: string, data: WhiteLabel) => (
        <ExternalLinkIcon
          onClick={() => {
            onAccess(data, link);
          }}
        />
      ),
    } : {},
    !isMobile ? {
      title: t('edit'),
      dataIndex: "slug",
      key: "link",
      width: "10%",
      render: (slug: string, data: WhiteLabel) => (
        data.kind === 'event' ?
          <Tooltip title={t("comingSoon")} placement="bottom">
            <div style={{ width: "fit-content" }}>
              <PenIcon color='placeholder' style={{ marginTop: "5px" }} />
            </div>
          </Tooltip> :
          <PenIcon
            style={{ marginTop: "5px", cursor: "pointer" }}
            onClick={() => {
              const link = onEdit(slug, data)
              window.open(link, "_blank");
            }}
          />
      ),
    } : {},
    {
      title: t('activate'),
      dataIndex: "is_active",
      key: "is_active",
      width: "10%",
      render: (is_active: string, data: any) => (
        data.kind === 'event' ?
          <Tooltip title={t("comingSoon")} placement="bottom">
            <div style={{ width: "fit-content" }}>
              <BaseToggle
                data={data}
                onChange={() => { }}
                initialCheck={false}
                disabled={true}
              />
            </div>
          </Tooltip> :
          data.is_draft ? (
            <Tooltip
              title={t('dashboard.activate.error')}
              arrowPointAtCenter
              placement="bottom"
              style={{ borderRadius: "20px" }}
              color={colors.body}
            >
              <div>
                <BaseToggle
                  data={data}
                  onChange={onToggleSwitch}
                  initialCheck={!!is_active}
                  disabled={data.is_draft}
                />
              </div>
            </Tooltip>
          ) : (
            <BaseToggle
              data={data}
              onChange={onToggleSwitch}
              initialCheck={!!is_active}
              disabled={data.is_draft}
            />
          )
      ),
    },
    !isMobile ? {
      title: t('delete'),
      width: "10%",
      render: (data: WhiteLabel) => (
        data.kind === 'event' ?
          <Tooltip title={t("comingSoon")} placement="bottom">
            <div style={{ width: "fit-content" }}>
              <TrashIcon color="placeholder" />
            </div>
          </Tooltip> :
          <TrashIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              setSelectedWl(data);
              setToggleModal(true);
            }}
          />
      )
    } : {
      title: '',
      width: "10%",
      dataIndex: "slug",
      key: "link",
      render: (slug: string, data: WhiteLabel) => (
        <MenuPopover
          onlyIcon
          buttonIcon={<ThreeDotsIcon color="line" />}
          menuItens={[
            {
              icon: <ExternalLinkIcon />,
              onClick: () => {
                onAccess(data, slug);
              },
              title: t('access'),
            },
            {
              icon: <PenIcon />,
              onClick: () => {
                const link = onEdit(slug, data)
                window.open(link, "_blank");
              },
              title: t('edit'),
            },
            {
              icon: <TrashIcon />,
              onClick: () => {
                setSelectedWl(data);
                setToggleModal(true);
              },
              title: t('delete'),
            }
          ]}
          positionX="left"
          positionY="bottom"
        />
      )
    },
  ];

  return (
    isLoading ? (<></>) : (
      <PageWrapper>
        <EventialsHeader userData={userData} />
        <ListPageTopBar
          name={name}
          setName={setName}
          type={type}
          setType={setType}
          showModal={showModal}
          setShowModal={setShowModal}
          handleCreate={handleCreate}
        />
        <Container>
          <Wrapper>
            {(isMobile && showModal) ? (
              <NewWlModalContent
                name={name}
                setName={setName}
                type={type}
                setType={setType}
                handleCreate={handleCreate}
              />
            ) : (
              <>
                <Header>
                  <TypographyWrapper>
                    <Typography
                      type={isMobile ? "heading5" : "heading4"}
                      color="title"
                      className="primary"
                    >
                      {t('manage')}
                      {!isMobile && (
                        <Typography type="heading4" className="secondary">
                          — White Labels
                        </Typography>
                      )}
                    </Typography>

                    <div>
                      <StyledTypography className="tertiary">
                        {t('dashboard.selectWL')}
                      </StyledTypography>
                    </div>
                  </TypographyWrapper>
                </Header>

                <TableWrapper>
                  <CustomTable dataSource={listOfWl} columns={columns} />
                </TableWrapper>
              </>
            )}
          </Wrapper>
        </Container>
        <BaseModal
          toggleModal={toggleModal}
          setToggleModal={setToggleModal}
          title={t('dashboard.modal.deleteWL.title')!}
          footer={[
            <ButtonWrapper>
              <ModalButton onClick={() => setToggleModal(false)}>
                {t('dashboard.modal.deleteWL.cancel')}
              </ModalButton>
              <ModalButton className="red-btn" onClick={() => onDelete()}>
                {t('dashboard.modal.deleteWL.confirm')}
              </ModalButton>
            </ButtonWrapper>,
          ]}
        >
          <p>{t('dashboard.modal.deleteWL.text', { whitelabel: selectedWl?.name })}</p>
        </BaseModal>
      </PageWrapper>
    ));
};

export default ListAndCreateWhitelabel;
